import React from "react";

export default function KontakOfficeInfo() {
  return (
    <div className="lg:col-span-5 space-y-6">
      <div className="rounded-3xl border border-slate-200 bg-white p-6 sm:p-8 dark:border-slate-800 dark:bg-slate-900 shadow-xl space-y-5">
        <h3 className="text-xl font-bold text-slate-900 dark:text-white">
          Informasi Kantor & Operational Studio
        </h3>

        <div className="space-y-4 text-xs sm:text-sm">
          <div className="flex items-start gap-3.5">
            <div className="w-10 h-10 rounded-xl bg-emerald-100 dark:bg-emerald-950/60 text-emerald-600 dark:text-emerald-400 flex items-center justify-center shrink-0 font-bold text-lg">
              📍
            </div>
            <div>
              <h4 className="font-bold text-slate-900 dark:text-white">
                Kantor Utama
              </h4>
              <p className="text-slate-600 dark:text-slate-400 leading-relaxed mt-0.5">
                Bandung, Jawa Barat, Indonesia (Menerima Meeting Online Google
                Meet / Zoom & On-Site Meeting).
              </p>
              <a
                href="#location"
                className="inline-flex items-center gap-1.5 mt-2 text-xs font-bold text-[#1f9913] hover:text-[#187e0f] dark:text-emerald-400 dark:hover:text-emerald-300 transition-colors"
              >
                <span>Lihat Titik Peta Google Maps</span>
                <span>↓</span>
              </a>
            </div>
          </div>

          <div className="flex items-start gap-3.5">
            <div className="w-10 h-10 rounded-xl bg-blue-100 dark:bg-blue-950/60 text-blue-600 dark:text-blue-400 flex items-center justify-center shrink-0 font-bold text-lg">
              ✉️
            </div>
            <div>
              <h4 className="font-bold text-slate-900 dark:text-white">
                Email Consultation
              </h4>
              <p className="text-slate-600 dark:text-slate-400 leading-relaxed mt-0.5">
                contact.galura@gmail.com
              </p>
            </div>
          </div>

          <div className="flex items-start gap-3.5">
            <div className="w-10 h-10 rounded-xl bg-amber-100 dark:bg-amber-950/60 text-amber-600 dark:text-amber-400 flex items-center justify-center shrink-0 font-bold text-lg">
              ⏰
            </div>
            <div>
              <h4 className="font-bold text-slate-900 dark:text-white">
                Jam Operasional Service
              </h4>
              <p className="text-slate-600 dark:text-slate-400 leading-relaxed mt-0.5">
                Senin – Minggu: 08.00 – 22.00 WIB (Fast Response WhatsApp 24/7).
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="p-6 rounded-3xl bg-gradient-to-br from-emerald-50 via-teal-50 to-white dark:from-emerald-950/30 dark:via-slate-900 dark:to-slate-900 border border-emerald-200 dark:border-emerald-800/60 shadow-md">
        <div className="flex items-center gap-3 mb-2">
          <span className="text-2xl">⚡</span>
          <h4 className="font-bold text-sm text-slate-900 dark:text-white">
            Solusi Cepat Tanpa Menunggu
          </h4>
        </div>
        <p className="text-xs text-slate-600 dark:text-slate-400 leading-relaxed">
          Tidak perlu mengirim formulir kontak email konvensional. Dapatkan
          respon langsung di HP Anda dalam waktu hitungan menit melalui layanan
          konsultan WhatsApp kami.
        </p>
      </div>
    </div>
  );
}
